import RBCLayer from "./RBCLayer";

class PLTLayer extends RBCLayer {
    id = "PLTLayer";
    label = "PLT Layer"
    drawer = 8;
    tools = [];

}

export default PLTLayer;